// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChildSideBar {
    z-index: 1;
    width: 15%;
    background: #FFFFFF;
    padding-top: 20px;
    min-width: fit-content;
    transition: all .5 ease;
    filter: drop-shadow(0px 4px 16px rgba(148, 93, 63, 0.05));
    border-left: 1px solid #E8DFD5;
}

.ChildSideBarList {
    list-style: none;
}

.classified_sidebar_heading {
    display: flex;
    padding: 10px;
    /* align-items: center; */
}

.classified_sidebar_heading>span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 20px;
    color: #594F42;
    letter-spacing: 2px;
    text-transform: uppercase;
}

.ChildSideBarItem {
    display: flex;
    gap: 20px;
    height: 40px;
    align-items: center;
    padding: 10px;
    cursor: pointer;
}

#item_active {
    background-color: #FFF3E8;
    border-right: 3px solid #FF8214;
}


.ChildSideBarList>#active {
    background-color: #FFF3E8;
    border-right: 3px solid #FF8214;
}

.ChildSideBarList>#active span{
    font-weight: 600 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    color: #594F42 !important;
}

#item_active span {
    font-weight: 600 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    color: #594F42 !important;
}

.ChildSideBarItem>span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
}

.sub_classified_list {
    height: 200px;
    overflow-y: scroll;
    /* -ms-overflow-style: none; */
}

.sub_classified_list::-webkit-scrollbar {
    width: 6px;
    height: 72px;
}

::-webkit-scrollbar-thumb {
    background: #D9D9D9;
    border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/CSS/ChildSidebar.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,yDAAyD;IACzD,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;;AAGA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".ChildSideBar {\n    z-index: 1;\n    width: 15%;\n    background: #FFFFFF;\n    padding-top: 20px;\n    min-width: fit-content;\n    transition: all .5 ease;\n    filter: drop-shadow(0px 4px 16px rgba(148, 93, 63, 0.05));\n    border-left: 1px solid #E8DFD5;\n}\n\n.ChildSideBarList {\n    list-style: none;\n}\n\n.classified_sidebar_heading {\n    display: flex;\n    padding: 10px;\n    /* align-items: center; */\n}\n\n.classified_sidebar_heading>span {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 20px;\n    color: #594F42;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n}\n\n.ChildSideBarItem {\n    display: flex;\n    gap: 20px;\n    height: 40px;\n    align-items: center;\n    padding: 10px;\n    cursor: pointer;\n}\n\n#item_active {\n    background-color: #FFF3E8;\n    border-right: 3px solid #FF8214;\n}\n\n\n.ChildSideBarList>#active {\n    background-color: #FFF3E8;\n    border-right: 3px solid #FF8214;\n}\n\n.ChildSideBarList>#active span{\n    font-weight: 600 !important;\n    font-size: 14px !important;\n    line-height: 20px !important;\n    color: #594F42 !important;\n}\n\n#item_active span {\n    font-weight: 600 !important;\n    font-size: 14px !important;\n    line-height: 20px !important;\n    color: #594F42 !important;\n}\n\n.ChildSideBarItem>span {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.sub_classified_list {\n    height: 200px;\n    overflow-y: scroll;\n    /* -ms-overflow-style: none; */\n}\n\n.sub_classified_list::-webkit-scrollbar {\n    width: 6px;\n    height: 72px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #D9D9D9;\n    border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
